export const CLIENT_NAME_REGEX = /^[a-zA-Z0-9_.@ -]+$/;

export const validateClientName = (value: string): string => {
  if (!value.trim()) return 'Client Name is required';
  if (!CLIENT_NAME_REGEX.test(value)) {
    return 'Only letters (a-z), numbers (0-9), spaces, underscores, hyphens, dots, and @ are allowed';
  }
  return '';
};
